module.exports = function clearIoDevices (runtime) {
  for (const deviceName in runtime.ioDevices) {
    if (deviceName) {
      const device = runtime.ioDevices[deviceName]
      if (device) {
        runtime.ioDevices[deviceName] = new device.constructor(runtime)
      }
    }
  }
}


